// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export const FINISH_BLOCK_TRANSFER = 'finishblocktransfer';
